module.exports = __webpack_public_path__ + "static/media/marketo-logo.b6a330cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marketo-logo.svg
// module id = 1292
// module chunks = 1